<template>
  <div class="type_tab" id="projectInquiry">
    <ul>
      <li v-for="(type,index) in navTabData" :key="index" @click="tabCheckType(type.nameEn)"
        :class="nowShowType == type.nameEn?'checkedLi':''">{{type.name}}</li>
    </ul>
    <p @click="sumitBox" class="sendButtom">我已添加完所有所需项目<br/>保存并发送询单</p>
</div>
</template>

<script>
export default {
  data(){
    return{
      navTabData: [{
        name: '酒店',
        nameEn: 'hotel',
        index:0,
      }, {
        name: '会议',
        nameEn: 'site',
        index:1,
      }, {
        name: '景点',
        nameEn: 'spot',
        propName:'spotProductInquiryList',
        index:2,
      }, {
        name: '用车',
        nameEn: 'traffic',
        propName:'trafficProductInquiries',
        desc:'车型',
        index:3,
      }, {
        name: '交通',
        nameEn: 'communication',
        propName:'bigTrafficProductInquiries',
        index:10,
        placeholder:'亲，正常会都按照经济舱报价，如有特殊舱位需求、或其他特殊需求等（如VIP通道等），请在此备注，我们将会按照要求，为您安排合适的产品',
      }, {
        name: '用餐',
        nameEn: 'restaurant',
        propName:'mealProductInquiries',
        index:4,
        placeholder:'如您需其他用餐类型,或您有指定想询价的餐厅,请在此填写具体需求(城市、用餐时间、餐厅名称等),我们将尽快为您提供您需要的专属特价',
      }, {
        name: '人员',
        nameEn: 'guide',
        propName:'trafficProductInquiries',
        placeholder:'如果您需要的不是上面的导游类型，请填写您需要什么样的导游？和其他备注说明',
        index:5,
      }, {
        name: '签证',
        nameEn: 'visa',
        propName:'visaProductInquiries',
        index:6,
        desc:'签证国家',
      }, {
        name: '商务',
        nameEn: 'business',
        propName:'businessProductInquiries',
        index:7,
        placeholder:'请在此处填写参访人员的行业背景，以及其他您想告知我们的需求，我们的商务专家将会尽快和您联系。'
      }, {
        name: '体验',
        nameEn: 'charact',
        propName:'chractProductInquiries',
        index:8,
      }, {
        name: '服务',
        nameEn: 'service',
        propName:'chractProductInquiries',
        index:9,
      }],
    }
  },
  methods:{
    tabCheckType (type) {
      this.$emit('tabCheckType',type)
    },
    sumitBox(){
      this.$emit('sumitBox')
    }
  },
  props:{
    sendButtom:{
      type:String,
      default:'我已添加完所有所需项目'
    },
    sendButtom2:{
      type:String,
      default:'保存并发送询单'
    },
    nowShowType:{
      type:String,
      default:'hotel'
    }
  }
}
</script>

<style lang="scss" scoped>
.type_tab{
  background: #f5f6f7;
  margin: 0.3rem 0;
  display: flex;
  justify-content: space-between;
  ul{
    display: flex;
    align-items: center;
    padding-left: 0.2rem;
    li {
      height: 0.44rem;
      width: 0.44rem;
      border-radius: 100%;
      border: 1px solid #bbbbbb;
      line-height: 0.44rem;
      text-align: center;
      color: #e64a19;
      margin: 0px 0.15rem;
      background: #ffffff;
    }
    .checkedLi {
      background: #db4e1a;
      border-color: #db4e1a;
      color: #fff;
    }
  }
  .sendButtom{
    width: 2.12rem;
    color: #fff;
    background: #db4e1a;
    font-size: 0.14rem;
    font-weight: bold;
    line-height: 0.21rem;
    cursor: pointer;
    height: 0.54rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}
</style>